// src/modules/app-views/ticket-events/pages/Init/components/tableColumns/currentPriceColumn.js
import translateX from 'utils/translateX';
import financialService from 'services/financialService';

function currentPriceColumn(buildColumnProps) {
  return {
    key: 'currentPrice',
    title: translateX('current_price'),
    dataIndex: 'currentPrice',
    width: 130,
    ...buildColumnProps('currentPrice', { sort: true }),
    render: val => (
      <span className="font-weight-semibold">
        {val != null ? financialService.formatCurrency(val) : '-'}
      </span>
    ),
  };
}

export default currentPriceColumn;
